import React from 'react'
import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'

export default function NotFound() {
    const { t, i18n } = useTranslation();

    return (
        <div className="d-flex align-items-center justify-content-center Notfound_Page" >
            <div className="section">
                <div className="container my-5 pt-5">
                    <div className="row align-items-center justify-content-center flex-column">
                        <div className="col-lg-6">
                            <div className="row gap-3 text-center">
                                <h1 className='SubTitle'>404</h1>
                                <h3><Trans i18nKey="NotFound_Title">الصفحة غير موجودة</Trans></h3>
                                <p  dir={i18n.dir()}>

                                <Trans
                                    i18nKey="NotFound_Message"
                                    values={{ HomeAnchor: t('HomeAnchor') }}
                                    components={{ Link: <Link to="/home" className='NotFound_Link' ></Link> }}
                                />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
